import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from "@ngx-translate/core";
import * as moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { InfoModalComponent } from 'src/app/components/info-Modal/info-modal.component';
import { UserStockDetails } from 'src/app/models/UserStocksDetails';
import { ReportDTO, SearchObj, Sector } from 'src/app/models/report';
import { ApiService } from 'src/app/services/api.service';
import { UrlConstants } from "src/app/models/urlConstants";
import { SettingsDto } from 'src/app/models/settings-enum-dto';

enum ReportTabId {
  TechnicalReport = 1,
  FundmentalReport = 2
}
@Component({
  selector: 'app-technical-reports',
  templateUrl: './technical-reports.component.html',
  styleUrls: ['./technical-reports.component.scss']
})

export class TechnicalReportsComponent implements OnInit {

  dtOptions = {
    paging: false,
    searching: false,
    autoWidth: true,
    info: false,
    responsive: true,
    order: [[0, "desc"]],
  };
  ReportTabId = ReportTabId
  reportTabId: number;
  types: { name; id; }[] = [ ];
  indexTypes: { name; id; }[] = [
    {
      name: "EGX_30",
      id: 30
    },
    {
      name: "EGX_70",
      id: 70
    },
    {
      name: "EGX_100",
      id: 100
    }
  ];
  allMarketNames: UserStockDetails[];
  searchObj: SearchObj = {};
  searchForm = new FormGroup({
    type: new FormControl(null, Validators.required),
    value: new FormControl()
  });
  report: ReportDTO[] = [];
  cols: string[] = [
    "date",
    "address",
    "report-type"
  ];
  rows: any[] = [];
  noDataFound: boolean = false;
  skip: number = 0;
  take: number = 60;
  currentPage: number = 0;
  loading = false;
  hasTechnicalAnalysis: boolean = UrlConstants.hasTechnicalAnalysis;
  hasFundmentalAnalysis: boolean = UrlConstants.hasFundmentalAnalysis;
  sectors: Sector[];

  hasMoreRows: boolean;
  constructor(
    public translate: TranslateService,
    private _service: ApiService,
    public dialog: MatDialog,
    private toastr: ToastrService,
  ) {
    this.types = [
    {
      name: "all",
      id: 3
    },
    {
      name: "general",
      id: 0
    },
    {
      name: "symbol",
      id: 2
    }
  ]
  }


  ngOnInit(): void {
    this.checkHasReport()
    this.fetchTechnicalAnalysisSymbols();
  }

    checkHasReport(){
    if(this.hasTechnicalAnalysis){
      this.reportTabId = ReportTabId.TechnicalReport
    } else if (this.hasFundmentalAnalysis){
      this.reportTabId = ReportTabId.FundmentalReport
    } else {
      this.reportTabId = 0
    }
    if (this.hasFundmentalAnalysis)
      this.fetchSectors();
    this.toggleOptionType(this.reportTabId);
  }

  getTypeNum($event) {
    !$event ? this.noDataFound = false : null;
    this.searchForm.get("type").setValue($event);
    this.searchObj.type = this.searchForm.get("type").value;
    this.searchForm.controls.value.setValidators(($event == 1 || $event == 2) ? [Validators.required] : null)
    this.searchForm.controls.value.updateValueAndValidity();
  }

  getTypeValue($event) {
    this.searchForm.get("value").setValue($event);
  }

  search() {
    if (this.searchForm.valid) {
      this.searchObj = this.searchForm.value
      if(this.reportTabId == ReportTabId.TechnicalReport){
        this.fetchTechnicalAnalysisList()
      } else {
        this.fetchFundmentalReportList()
      }
    }
  }

  fetchTechnicalAnalysisSymbols() {
    this.searchForm.get("type").setValue(3);

    this._service.fetchTechnicalAnalysisSymbols().subscribe(
      (res) => {
        this.allMarketNames = res;
        if((this.reportTabId == ReportTabId.TechnicalReport) && this.hasTechnicalAnalysis){
          this.fetchTechnicalAnalysisList({ type: 3, Skip: 0, Take: 60 })
        } else if ((this.reportTabId == ReportTabId.FundmentalReport) && this.hasFundmentalAnalysis){
          this.fetchFundmentalReportList()
        }
      }
    )
  }

  fetchTechnicalAnalysisList(searchObj?: SearchObj) {
    this.searchObj.Skip = 0;
    this.searchObj.Take = 60;
    this.loading = true;
    this._service.fetchTechnicalAnalysisList(searchObj ? searchObj : this.searchObj).subscribe(
      (res: ReportDTO[]) => {
        if (res.length > 0) {
          this.noDataFound = false;
          this.report = res;
          this.setRows(this.report);
          this.loading = false;
        } else {
          this.report = [];
          this.noDataFound = true;
          this.loading = false;
        }
      }
    )
  }

    fetchFundmentalReportList(searchObj?: SearchObj) {
    // TODO:: Add Endpoint After BE
    this.report = []
          this.noDataFound = true;
    this.searchObj.Skip = 0;
    this.searchObj.Take = 60;
    this.loading = true;
    this._service.fetchFundmentalAnalysisList(searchObj ? searchObj : this.searchObj).subscribe(
      (res: ReportDTO[]) => {
        if (res.length > 0) {
          this.noDataFound = false;
          this.report = res;
          this.setRows(this.report);
          this.loading = false;
          if (res.length == 10)
            this.hasMoreRows = true;
        } else {
          this.report = [];
          this.noDataFound = true;
          this.loading = false;
        }
      }
    )
  }

  
  fetchSectors(){
    this._service.GetSectors().subscribe(result => {
      this.sectors = result
    })
  }

  setRows(report: ReportDTO[]) {
    this.rows = report.map((row) => {
      return {
        PagesId: row.PagesId,
        CreateDate: row.CreateDate,
        title: (this.translate.currentLang == 'en') ? row.TitleEn : row.TitleAr,
        type:
          row.IsGeneral ? this.translate.currentLang == 'en' ? 'General' : 'عام' :
            row.SymbolCode ?
              (this.translate.currentLang == 'en') ?
                this.allMarketNames?.find((market) => market.SYMBOL_CODE == row?.SymbolCode)?.eng_shortname :
                this.allMarketNames?.find((market) => market.SYMBOL_CODE == row?.SymbolCode)?.arb_shortname :
              row.IndexType ?
                this.indexTypes?.find((index) => index.id == row?.IndexType)?.name
                : null,
        Desc: {
          ShortDesc: this.translate.currentLang == 'en' ? row.ShortDescEn : row.ShortDescAr,
          Desc: this.translate.currentLang == 'en' ? row.DescEn : row.DescAr
        }
      }
    })
  }

  downloadPDF(rowData) {
    const pageType = this.reportTabId == ReportTabId.TechnicalReport ? 6 : 8;
    const fileId = rowData.PagesId;
    
    this.loading = true;
    this._service.fetchTechnicalAnalysisFile(pageType, fileId).subscribe(
      (res) => {
        this.loading = false;
        if (res && res.FilePath) {
          window.open(UrlConstants.backofficeUrl + res.FilePath, "_blank");
        } else {
          this.toastr.warning(
            this.translate.instant('noFilesFound'),
            this.translate.instant('warning')
          );
        }
      },
      (error) => {
        this.loading = false;
        this.toastr.error(
          this.translate.instant('errorDownloadingFile'),
          this.translate.instant('error')
        );
      }
    );
  }

  getFilename(fullPath) {
    return fullPath.replace(/^.*[\\\/]/, '');
  }

  openDescModal(item) {
    this.dialog.open(
      InfoModalComponent,
      {
        maxHeight: '80vh',
        panelClass: "order-dialog-container",
        data: {
          item
        },
        direction: this.translate.currentLang == "ar" ? "rtl" : "ltr",
      }
    );
  }

  selectReport(reportTabId){
    this.reportTabId = reportTabId
    this.toggleOptionType(reportTabId);
    if((this.reportTabId == ReportTabId.TechnicalReport) && this.hasTechnicalAnalysis){
      this.fetchTechnicalAnalysisList({ type: 3, Skip: 0, Take: 60 })
    } else if ((this.reportTabId == ReportTabId.FundmentalReport) && this.hasFundmentalAnalysis){
      this.fetchFundmentalReportList()
    }
    if((this.searchObj?.type == 4) || (this.searchObj?.type == 1)){
      this.searchForm.get('type')?.setValue(null)
      this.searchForm.get('value')?.setValue(null)
      this.searchObj.type = null;
      this.searchObj.value = null;
    }
  }

  toggleOptionType(reportTabId : number){
    type TypeItem = { name: string; id: number };
    const INDEX_ITEM: TypeItem = { name: "index", id: 1 };
    const SECTOR_ITEM: TypeItem = { name: "sector", id: 4 };
    const hasIndex = this.types.some(t => t.id === INDEX_ITEM.id && t.name === INDEX_ITEM.name);
    const hasSector = this.types.some(t => t.id === SECTOR_ITEM.id && t.name === SECTOR_ITEM.name);

    this.reportTabId = reportTabId
    if((this.reportTabId == ReportTabId.TechnicalReport) && this.hasTechnicalAnalysis){
      this.types = [
        ...this.types.filter(t => !(t.id === SECTOR_ITEM.id && t.name === SECTOR_ITEM.name)),
        ...(hasIndex ? [] : [INDEX_ITEM]),
      ];
    } else if ((this.reportTabId == ReportTabId.FundmentalReport) && this.hasFundmentalAnalysis){
      this.types = [
          ...this.types.filter(t => !(t.id === INDEX_ITEM.id && t.name === INDEX_ITEM.name)),
          ...(hasSector ? [] : [SECTOR_ITEM]),
        ];
    }
  }
}
